(function () {
  function initPO(root) {
    if (!root || root.dataset.poInit === "1") return;
    root.dataset.poInit = "1";

    const onceRadio = root.querySelector('input.po__radio[value="once"]');
    const subRadio  = root.querySelector('input.po__radio[value="subscription"]');

    const expand    = root.querySelector("[data-po-expand]");
    const select    = root.querySelector("[data-po-selling-plan-select]");

    const subPriceEl   = root.querySelector("[data-po-sub-price]");
    const subCompareEl = root.querySelector("[data-po-sub-compare]");

    function setExpand(open) {
      if (!expand) return;
      expand.hidden = !open;
    }

    function setSelectEnabled(enabled) {
      if (!select) return;

      if (enabled) {
        select.removeAttribute("disabled");
      } else {
        // IMPORTANT: If disabled, Shopify won't submit selling_plan => one-time purchase
        select.setAttribute("disabled", "disabled");
      }
    }

    function updateSubPricesFromSelectedOption() {
      if (!select || !subPriceEl) return;
      const opt = select.options[select.selectedIndex];
      if (!opt) return;

      const price = opt.getAttribute("data-po-price") || "";
      const compare = opt.getAttribute("data-po-compare") || "";

      subPriceEl.textContent = price;

      if (subCompareEl) {
        // Hide compare if it matches price or empty
        if (!compare || compare === price) {
          subCompareEl.hidden = true;
          subCompareEl.textContent = compare;
        } else {
          subCompareEl.hidden = false;
          subCompareEl.textContent = compare;
        }
      }
    }

    function setMode(mode) {
      const isSub = mode === "subscription";

      // Expand section
      setExpand(isSub);

      // Enable/disable selling_plan select
      setSelectEnabled(isSub);

      // When switching to subscription ensure prices match selected plan
      if (isSub) updateSubPricesFromSelectedOption();
    }

    // Initial
    const initialMode =
      subRadio && subRadio.checked ? "subscription" : "once";
    setMode(initialMode);

    // Events
    if (onceRadio) {
      onceRadio.addEventListener("change", function () {
        if (onceRadio.checked) setMode("once");
      });
    }

    if (subRadio) {
      subRadio.addEventListener("change", function () {
        if (subRadio.checked) setMode("subscription");
      });
    }

    if (select) {
      select.addEventListener("change", function () {
        // Update UI prices immediately
        updateSubPricesFromSelectedOption();
      });
    }
  }

  function boot() {
    document.querySelectorAll("[data-po]").forEach(initPO);

    // In themes with partial rerender (Impact uses product-rerender), re-init when DOM updates
    const obs = new MutationObserver(() => {
      document.querySelectorAll("[data-po]").forEach(initPO);
    });
    obs.observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
